import { BundleSelection } from '@df/catalog/product/bundle-selection';
import { IProductDataV3, Product } from '@df/catalog/product/product';
import { App } from '@df/core/app';
import { NgInject } from '@df/ng/ng-inject';
import { Nexus } from '@tomandco/nexus-api-types';

/**
 * @deprecated use Nexus.Lib.Customer.Order.HistoryOrderItem instead
 */
export interface IHistoryOrderItemData extends Nexus.Lib.Customer.Order.HistoryOrderItem {}

/**
 * @deprecated use Nexus.Lib.Customer.Order.HistoryOrderItemOption instead
 */
export interface IHistoryOrderItemDataOption extends Nexus.Lib.Customer.Order.HistoryOrderItemOption {}

export interface IHistoryOrderItemConfigurableOption {
    code: string;
    value: any;
}

export class HistoryOrderItem {
    @NgInject(App)
    private app!: App;

    protected _cache: any = {};

    constructor(public data: Nexus.Lib.Customer.Order.HistoryOrderItem) {}

    get id() {
        return this.data.id;
    }

    get product(): Product<IProductDataV3> | undefined {
        return <Product<IProductDataV3> | undefined>this.app.resources.product.getExisting(this.data.product_id);
    }

    get configurableOptions(): IHistoryOrderItemConfigurableOption[] | undefined {
        const _cache = this._cache;

        if (_cache.configurableOptions === undefined) {
            const product = this.product;
            if (product && product.data) {
                const parent = product.parent;
                const codes = parent.configurableAttributeCodes;
                if (codes) {
                    _cache.configurableOptions = <IHistoryOrderItemConfigurableOption[]>codes
                        .map((code: string) => {
                            if (product.data && product.data[code]) {
                                return <IHistoryOrderItemConfigurableOption>{
                                    code,
                                    value: product.data[code]
                                };
                            }
                            return undefined;
                        })
                        .filter(i => !!i);
                }
            }
        }
        return _cache.configurableOptions;
    }

    get bundleSelection(): BundleSelection | undefined {
        if (this.product?.isBundle) {
            // convert order item syntax to basket/FE syntax
            const bundleOption = this.data.request?.bundle_option;
            if (bundleOption) {
                const bundleOptionQties = this.data.request?.bundle_option_qty || {};
                const bundleOptions: Nexus.Lib.Basket.BundleSelectionData = {};
                for (const bundleOptionId in bundleOption) {
                    const selection: Nexus.Lib.Basket.BundleOptionSelectionSelection = {};
                    for (const selectionId of bundleOption[bundleOptionId]) {
                        selection[selectionId] = bundleOptionQties[bundleOptionId] || 0;
                    }
                    bundleOptions[bundleOptionId] = selection;
                }
                return this.product.getBundleSelectionObject(bundleOptions);
            }
        }
        return undefined;
    }
}

export const historyOrderItemFactory = {
    instance: HistoryOrderItem
};
